import { canv } from "@/canv/global";
import { drawRoundedRect, isOverRect } from "@/canv/utils";
import { TextWidgetV2 } from "@/elements/text/textV2";
import type { AdvancedCardProgressDataItem, CardProgressDataItem } from "./types";

export class CardWidgetSlider {
    constructor(startX: number, startY: number, width: number) {
        this.height = 25;

        this.textPart = new TextWidgetV2();

        this.textPart.menuTextSize(18);

        this.updateDims(startX, startY, width);
    }

    updateDims(startX: number, startY: number, width: number) {
        this.startX = startX;
        this.startY = startY;
        this.width = width;
        this.sliderWidth = this.width - 68; // 65 подобрано, чтобы вмещалась число процентов (100)
        this.updateTextPosition();
    }

    updateTextPosition() {
        this.textPart.menuTextAlign("right");
        this.textPart.startX = this.startX + this.width - this.textPart.width;
        this.textPart.startY =
            this.startY + this.height / 2 - this.textPart.height / 2 + this.textPart.lineHeight;
        this.textPart.updateDims();
    }

    setProgressData(progressData: AdvancedCardProgressDataItem, smooth = false) {
        if (smooth && this.progressData != null) {
            // при создании виджета и первом вызове setProgressData,  this.progressData == null
            this.transitionProgress = this.progressData.currentProgress;
        }

        this.progressData = progressData;

        this.textPart.setText(`${Math.round(this.progressData.currentProgress * 100)}%`);
        this.textPart.menuTextColor(this.progressData.majorColor || "", true);
        this.updateTextPosition();
    }

    draw(drawCatcher: boolean, isInteractionSlider: boolean) {
        if (!drawCatcher) this.drawRatio = 0;

        let sliderHeight = 4;

        if (isInteractionSlider) {
            sliderHeight = 8;
        }

        // slider background
        drawRoundedRect(
            this.startX,
            this.startY + this.height / 2 - sliderHeight / 2,
            this.sliderWidth,
            sliderHeight,
            sliderHeight * 10,
        );
        canv.ctx.fillStyle = "#D9D9D9";
        canv.ctx.fill();

        let drawProgress = this.progressData?.currentProgress;

        // slider filler
        if (this.progressData && this.transitionProgress !== -1) {
            canv.redraw();
            drawProgress = this.transitionProgress;
            if (this.transitionProgress <= this.progressData.currentProgress) {
                this.transitionProgress += 0.03;
                if (this.transitionProgress >= this.progressData.currentProgress) {
                    this.transitionProgress = -1;
                }
            } else {
                this.transitionProgress -= 0.03;
                if (this.transitionProgress <= this.progressData.currentProgress) {
                    this.transitionProgress = -1;
                }
            }
        }

        drawRoundedRect(
            this.startX,
            this.startY + this.height / 2 - sliderHeight / 2,
            (drawProgress || 1) * this.sliderWidth,
            sliderHeight,
            sliderHeight * 10,
        );

        if (this.progressData?.majorColor) {
            canv.ctx.fillStyle = this.progressData.majorColor;
        }

        canv.ctx.fill();

        this.textPart.draw();

        if (drawCatcher) {
            this.drawCatcher(drawProgress as number, isInteractionSlider);
        }
    }

    drawCatcher(drawProgress: number, isInteractionSlider: boolean) {
        const size = this.sliderCatcherSize;
        const currentWidth = size * this.drawRatio;
        const currentHeight = size * this.drawRatio;

        const catcherCenterX = this.startX + drawProgress * this.sliderWidth;
        const catcherCenterY = this.startY + this.height / 2;

        const modifiedStartX = catcherCenterX - currentWidth / 2;
        const modifiedStartY = catcherCenterY - currentHeight / 2;

        drawRoundedRect(
            modifiedStartX,
            modifiedStartY,
            currentWidth,
            currentHeight,
            10 * currentWidth,
        );

        if (this.drawRatio < 1) {
            this.drawRatio += 0.05;
            canv.redraw();
        }

        canv.ctx.strokeStyle = "#0B99FF";
        canv.ctx.fillStyle = "#FFFFFF";
        if (
            isOverRect(modifiedStartX, modifiedStartY, currentWidth, currentHeight) ||
            isInteractionSlider
        ) {
            canv.ctx.fillStyle = "#0B99FF";
        }
        canv.ctx.lineWidth = 5;
        canv.ctx.stroke();
        canv.ctx.fill();
    }

    calculateProgress() {
        const pt = canv.actionManager.getActionPoint();
        const x = pt.x;

        let result = 0;

        if (x < this.startX) {
            result = 0;
        } else if (x > this.startX + this.sliderWidth) {
            result = 1;
        } else {
            const newProgress = (x - this.startX) / this.sliderWidth;
            result = newProgress;
        }

        return result;
    }

    isOverSliderCatcher() {
        const catcherCenterX =
            this.startX + (this.progressData?.currentProgress || 1) * this.sliderWidth;
        const catcherCenterY = this.startY + this.height / 2;

        return isOverRect(
            catcherCenterX - this.sliderCatcherSize / 2,
            catcherCenterY - this.sliderCatcherSize / 2,
            this.sliderCatcherSize,
            this.sliderCatcherSize,
        );
    }

    startX = 0;
    startY = 0;
    width = 0;
    height = 0;
    sliderWidth = 0;
    textPart: TextWidgetV2;
    transitionProgress = -1;
    drawRatio = 0;
    progressData: AdvancedCardProgressDataItem | null = null;
    sliderCatcherSize = 25;
}
